
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceConsumerUnitCategoryPesquisarConsumerUnit: 'consumerUnitCategory.pesquisarConsumerUnit',
  nmInterfaceConsumerUnitCategoryGravar: 'consumerUnitCategory.gravar',
  nmInterfaceConsumerUnitCategoryAlterar: 'consumerUnitCategory.alterar',
  nmInterfaceConsumerUnitCategoryExcluir: 'consumerUnitCategory.excluir',

  loadDatatable: async function () {
    return await repository.resolveDatatable(this.nmInterfaceConsumerUnitCategoryPesquisarConsumerUnit)
  },

  async loadDatatableModel (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceConsumerUnitCategoryPesquisarConsumerUnit, { ...params })
  },

  async loadForm () {
    return await repository.resolve(this.nmInterfaceConsumerUnitCategoryGravar)
  },

  async loadFormAlterar (params) {
    return await repository.resolveForm(this.nmInterfaceConsumerUnitCategoryAlterar, params)
  },

  async createUnitCategory (params) {
    return await repository.create(this.nmInterfaceConsumerUnitCategoryGravar, { ...params })
  },

  async deleteCategory (id) {
    return await repository.delete(this.nmInterfaceConsumerUnitCategoryExcluir, { id })
  }
}
